module.exports = __webpack_public_path__ + "static/l8-case-image-1-71853fa2269fe3f912fd647f14a36ed2.jpg";